import React from 'react'
import ReactFlagsSelect from 'react-flags-select'

const Avatar = (props) => (
    <div className={`c-avatar ${props.modifierClasses}`}>
      <ReactFlagsSelect
        defaultCountry={props.language}
        showSelectedLabel={false}
      />
    </div>
)

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/Avatar.jsx